import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/echeances`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    Authorization: `Bearer ${token}`,
  };
};

export const getAllEcheances = async () => {
  const response = await axios.get(`${apiUrl}/allEcheances`, {
    headers: getAuthHeaders(),
  });

  return response.data;
};

export const getEcheanceById = async (echeanceId) => {
  const response = await axios.get(`${apiUrl}/echeanceById/${echeanceId}`, {
    headers: getAuthHeaders(),
  });

  return response.data;
};

export const addEcheance = async (echeance) => {
  const response = await axios.post(`${apiUrl}/addEcheance`, echeance, {
    headers: getAuthHeaders(),
  });

  return response.data;
};

export const updateEcheance = async (echeanceId, echeance) => {
  const response = await axios.patch(
    `${apiUrl}/updateEcheance/${echeanceId}`,
    echeance,
    {
      headers: getAuthHeaders(),
    }
  );

  return response.data;
};

export const deleteEcheance = async (echeanceId) => {
  const response = await axios.delete(
    `${apiUrl}/deleteEcheance/${echeanceId}`,
    {
      headers: getAuthHeaders(),
    }
  );

  return response.data;
};